module.exports = __webpack_public_path__ + "img/06.76d33acb.jpg";